import React from "react";
import { motion } from "framer-motion";
import { Icon } from "./icon";

export const Features = (props) => {
  const items = props.data || [];

  return (
    <section id="features" className="section bg-white">
      <div className="container">
        <div className="flex flex-col gap-8 lg:flex-row lg:items-end lg:justify-between">
          <div className="max-w-2xl">
            <span className="eyebrow">Why Mercuri</span>
            <h2 className="section-heading mt-6">
              The things clients tell us
              <span className="gradient-text"> actually matter</span>
            </h2>
          </div>
          <p className="max-w-md text-lg leading-relaxed text-ink-muted">
            Good software is table stakes. What sets an engagement apart is how
            predictable it feels while it's happening.
          </p>
        </div>

        <div className="mt-16 grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-4">
          {items.map((d, i) => (
            <motion.article
              key={d.title}
              initial={{ opacity: 0, y: 26 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ delay: i * 0.08, duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
              className="card-interactive group overflow-hidden"
            >
              {/* Crimson accent bar that draws in on hover */}
              <span
                className="absolute inset-x-0 top-0 h-1 origin-left scale-x-0 bg-gradient-to-r from-crimson-600 to-crimson-400 transition-transform duration-500 ease-smooth group-hover:scale-x-100"
                aria-hidden="true"
              />

              <div className="icon-tile icon-tile-hover">
                <Icon name={d.icon} className="h-6 w-6" />
              </div>

              <h3 className="mt-6 text-lg font-bold text-navy-900">{d.title}</h3>
              <p className="mt-3 text-[0.95rem] leading-relaxed text-ink-muted">{d.text}</p>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
};
